import api from "../Utils/axios";
import { adminV1Base } from "../Utils/connection_strings";
import { filterParams } from "../Utils/helpers";

export const getPromoCodes = (page, perPage, search_string, status, from, to) => {
    return api.get(`${adminV1Base}/promo-code/get`, {
        params: filterParams({
            page,
            limit: perPage,
            keyword: search_string,
            visibilityStatus: status,
            "createdAt[from]": from,
            "createdAt[to]": to,
        }),
    });
};

export const createPromoCode = (data) => {
    return api.post(`${adminV1Base}/promo-code/create`, data, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
};

export const editPromoCode = (data) => {
    return api.post(`${adminV1Base}/promo-code/edit`, data, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
};

export const getPromoCodeDetails = (id) => {
    return api.get(`${adminV1Base}/promo-code/get`, {
        params: {
            _id: id,
        },
    });
};

export const handlePromoCodeStatus = (id) => {
    return api.post(`${adminV1Base}/promo-code/handle-status`, { id });
};

export const deletePromoCode = (id) => {
    return api.post(`${adminV1Base}/promo-code/delete`, { id });
};
